var deleteLabResult = function(event) {
  event.preventDefault();

  var $target = $(event.currentTarget || event.target);
  var $container = $target.closest(".js-lab-result-container");
  var isNewLabResult = $(".js-lab-result-id", $container).length;

  if (isNewLabResult) {
    $container.slideUp("normal", function() { $(this).remove(); } );
  }
}

var prepDateTime = function($scope){
  var $datetimeInputs = ($scope || $(".js-lab-results-container")).find(".datetimepicker");

  $datetimeInputs.each(function(){
    var $input = $(this);

    if ($input.data("xdsoft_datetimepicker")) return;

    $input.datetimepicker({
      format: "Y-m-d H:i",
      minDate: "1970/01/02"
    });
  });
}

var addLabResult = function() {
  $("body").off("click", ".js-add-lab-result");
  $("body").on("click", ".js-add-lab-result", function(event) {
    event.preventDefault();

    var content = $(this).data("partial");
    var new_id = new Date().getTime();
    var input_names = /consult\[lab_results_attributes\]\[\d+\]/g;
    var input_ids = /consult_lab_results_attributes_\d+/g;
    content = content.replace(input_names, "consult[lab_results_attributes][" + new_id + "]");
    content = content.replace(input_ids, "consult_lab_results_attributes_" + new_id);

    var $content = $(content);
    $(".js-lab-results-container").append($content);
    prepDateTime($content);
  });

  $("body").off("click", ".js-delete-lab-result");
  $("body").on("click", ".js-delete-lab-result", deleteLabResult);

  prepDateTime();
}

$(document).ready(addLabResult);
$(document).on("page:load turbolinks:load turbo:load", addLabResult);